import writeModuleStylesToCss from './css/writeModuleWrapperStylesToCss';
import useLiveUpdateCss from './useLiveUpdateCss';
export default function ModuleStyleRenderer({
  module,
  breakpointMediaQueries
}) {
  const styles = module.getValue().styles;
  const css = writeModuleStylesToCss(module.getId(), styles, breakpointMediaQueries);
  useLiveUpdateCss(css, breakpointMediaQueries);
  return null;
}